import {Component, Input, OnInit} from '@angular/core';
import {ExgModalService} from 'exc-controls-v2';
import {ExcRestService} from 'exc-rest-v2';
import {ExcTranslation} from 'exc-core-v2';
import {PDFDocumentProxy} from 'ng2-pdf-viewer';

@Component({
  selector: 'app-modal-pdf-viewer',
  templateUrl: './modal-pdf-viewer.component.html',
  styles: [
  ]
})
export class ModalPdfViewerComponent extends ExcTranslation  implements OnInit {
  @Input() data: any;

  url: any;
  pdf: PDFDocumentProxy | undefined;
  uiStateShowLoading = false;

  constructor(public modalService: ExgModalService,
              private excRestService: ExcRestService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.url = this.excRestService.computeUrl(this.data.endpoint, {
      rcptID: this.data.rcptID,
    });
    this.uiStateShowLoading = true;
  }

  close(): void {
    this.modalService.close();
  }

  onLoaded(pdf: PDFDocumentProxy): void {
    this.pdf = pdf;
    this.uiStateShowLoading = false;
  }

  downloadDocument(): void {
    window.open(this.url);
  }
}
